import { createContext, useEffect, useState, useCallback } from "react"
import { GoogleAuthProvider, getAuth, signInWithRedirect, getRedirectResult, signOut } from "firebase/auth"
import { useNavigate, useLocation } from "react-router-dom"
import inititializeAuthentication from "../services/firebase/firebase.init"

inititializeAuthentication()

export const AuthContext = createContext()
AuthContext.displayName = "Authentication Context"

function nomeDoEmail(email) {
   const parte = email.split("@")[0]
   const nomes = parte.split(/[.\-_ ]+/)
   const capitalizados = nomes.map((nome) => nome.charAt(0).toUpperCase() + nome.slice(1))
   return capitalizados.join(" ")
}

export function AuthContextProvider({ children }) {
   const navigate = useNavigate()
   const location = useLocation()

   const [authenticated, setAuthenticated] = useState(() => !!localStorage.getItem("@AuthFirebase:token"))
   const [loading, setLoading] = useState(true)
   const [user, setUser] = useState(() => {
      const storedUser = localStorage.getItem("@AuthFirebase:user")
      return storedUser ? JSON.parse(storedUser) : null
   })

   const logout = useCallback(async () => {
      try {
         const auth = getAuth()
         await signOut(auth)
      } catch (error) {
         console.error("Erro durante o logout:", error.message)
      } finally {
         setUser(null)
         setAuthenticated(false)
         localStorage.removeItem("@AuthFirebase:token")
         localStorage.removeItem("@AuthFirebase:user")
         navigate("/login")
      }
   }, [navigate])

   useEffect(() => {
      const checkRedirectResult = async () => {
         try {
            const auth = getAuth()
            console.log("Verificando getRedirectResult...")
            const result = await getRedirectResult(auth)
            console.log("Resultado do redirect:", result)

            if (result && result.user) {
               const loggedUser = result.user
               console.log("Usuário retornado:", loggedUser)

               if (loggedUser.email.endsWith("@bowe.co")) {
                  const userData = {
                     displayName: loggedUser.displayName || nomeDoEmail(loggedUser.email),
                     email: loggedUser.email,
                     photoURL: loggedUser.photoURL || "",
                  }

                  localStorage.setItem("@AuthFirebase:token", loggedUser.accessToken)
                  localStorage.setItem("@AuthFirebase:user", JSON.stringify(userData))

                  setUser(userData)
                  setAuthenticated(true)

                  const params = new URLSearchParams(location.search)
                  const redirect = params.get("redirect")

                  navigate(redirect ? `/${redirect}` : "/")
               } else {
                  alert("Apenas emails com domínio 'bowe.co' podem acessar.")
                  await logout()
               }
            } else {
               console.log("Nenhum usuário retornado pelo redirect.")
            }
         } catch (error) {
            console.error("Erro ao obter resultado do redirect:", error.message)
         } finally {
            setLoading(false)
         }
      }

      checkRedirectResult()
   }, [location.search, navigate, logout]) // ✅ logout incluído nas dependências

   const handleLogin = async (param) => {
      if (param && param.endsWith("@bowe.co")) {
         const displayName = nomeDoEmail(param)
         const userData = { displayName, email: param }

         setUser(userData)
         setAuthenticated(true)
         localStorage.setItem("@AuthFirebase:token", "acesso-uso-unico")
         localStorage.setItem("@AuthFirebase:user", JSON.stringify(userData))

         navigate("/")
         return
      }

      try {
         const auth = getAuth()
         const provider = new GoogleAuthProvider()
         provider.setCustomParameters({ hd: "bowe.co" })
         await signInWithRedirect(auth, provider)
      } catch (error) {
         console.error("Erro ao fazer login com redirect:", error.message)
         alert("Erro ao fazer login com o Google. Tente novamente.")
      }
   }

   return (
      <AuthContext.Provider value={{ handleLogin, authenticated, user, logout, loading }}>
         {children}
      </AuthContext.Provider>
   )
}
